export const DUTCH_PAYMENT_STATUS_REQUEST = 'DUTCH_PAYMENT_STATUS_REQUEST';
export const DUTCH_PAYMENT_STATUS_SUCCESS = 'DUTCH_PAYMENT_STATUS_SUCCESS';
export const DUTCH_PAYMENT_STATUS_ERROR = 'DUTCH_PAYMENT_STATUS_ERROR';
export const DUTCH_PAYMENT_RETRY_ERROR = 'DUTCH_PAYMENT_RETRY_ERROR';
export const DUTCH_PAYMENT_RETRY_REQUEST = 'DUTCH_PAYMENT_RETRY_REQUEST';
export const DUTCH_PAYMENT_RETRY_SUCCESS = 'DUTCH_PAYMENT_RETRY_SUCCESS';
